import React from "react";
import PhoneNav from "../PhoneNav";
import Property1Frame293 from "../Property1Frame293";
import Footer4 from "../Footer4";
import "./Gallery.css";

function Gallery(props) {
  const { gallery, phoneNavProps, property1Frame293Props } = props;

  return (
    <div className="gallery-1 screen">
      <PhoneNav image22={phoneNavProps.image22} className={phoneNavProps.className} />
      <div className="frame-142-1">
        <div className="gallery-2 poppins-medium-tundora-18px">{gallery}</div>
      </div>
      <div className="frame-293">
        <Property1Frame293 {...property1Frame293Props} />
      </div>
      <Footer4 />
    </div>
  );
}

export default Gallery;
